import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import 'react-datepicker/dist/react-datepicker.css'
import EmployeeCategoryFilter from 'support/filters/EmployeeCategoryFilter'
import { useEnvValue } from '@morningtrain/react-helpers'
import { Env } from '@morningtrain/helpers'

function ToggleEmploymentCategoryFilter (props) {
  const defaultEmploymentCategory = Env.get('user.suggested_employment_type.type')
  const [location, setLocation] = useEnvValue('toggle.location', defaultEmploymentCategory)

  const onChange = (change) => {
    setLocation(change)
  }

  return (
    <EmployeeCategoryFilter
      name='location'
      allowViewAll={false}
      onChange={onChange}
      defaultValue={defaultEmploymentCategory}
    />
  )
}

ToggleEmploymentCategoryFilter.defualtProps = {}

ToggleEmploymentCategoryFilter.propTypes = {
  name: PropTypes.string.isRequired
}

export default observer(ToggleEmploymentCategoryFilter)
